import { PageHeader } from '@/components/page-header';

import { AddOrganizationForm } from './add-organization-form/add-organization-form';
import { OrganizationsTable } from './organizations-table/organizations-table';

export const OrganizationsPage = () => {
  return (
    <>
      <PageHeader title="" subtitle="Organizations">
        <AddOrganizationForm />
      </PageHeader>
      <OrganizationsTable />
    </>
  );
};
